import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o/public_api';

@Component({
  selector: 'app-showcase-carousel',
  templateUrl: './showcase-carousel.component.html',
  styleUrls: ['./showcase-carousel.component.scss']
})
export class ShowcaseCarouselComponent implements OnInit {
  carouselImages: Array<string> = [
    '/assets/images/ClientPortalVector.png',
    '/assets/images/DashboardVector.png',
    '/assets/images/BookingsVector.png',
    '/assets/images/PrefrencesVector.png',
    '/assets/images/LoginVector2.png',
  ]

  constructor() { }

  ngOnInit(): void {
  }
  
  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    dots: true,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: true
  }
}
